export default __webpack_public_path__ + "static/media/921.b210479b.png";